import Link from 'next/link';
import Markdown from 'react-markdown';

const BUTTON_CLASSES = {
  default: 'bg-brand-500 hover:bg-brand-600 text-white',
  secondary: 'border border-white text-white hover:text-brand-500 hover:border-brand-500',
  tertiary: 'text-white underline hover:text-brand-500'
};

const GlossaryCtaDark = ({ title, description, note, buttons = [] }) => {
  if (!title && !description && buttons.length === 0) return null;

  return (
    <section className="bg-grey-950 -mx-[5vw] my-4 rounded-3xl px-[5vw] py-16 text-center text-white xl:mx-0 xl:px-12">
      {title && (
        <h2 className="mx-auto mb-5 max-w-[640px] text-white [&_p]:my-0">
          <Markdown>{title}</Markdown>
        </h2>
      )}
      {description && <p className="mx-auto mb-8 max-w-[520px] text-base text-white/70">{description}</p>}
      {buttons.length > 0 && (
        <div className="flex flex-wrap justify-center gap-4">
          {buttons.map((button) => {
            const variant = BUTTON_CLASSES[button.variant] ? button.variant : 'default';
            return (
              <Link
                key={button.id}
                href={button.url || '#'}
                className={`inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-sm font-medium transition-colors ${BUTTON_CLASSES[variant]}`}
              >
                {button.label}
              </Link>
            );
          })}
        </div>
      )}
      {note && <p className="mt-5 text-xs text-white/35">{note}</p>}
    </section>
  );
};

export default GlossaryCtaDark;
